export default "__VITE_ASSET__CAWJaaPM__"